import { storageApiClient } from 'myNet'
import conf from 'conf'

export type FileInfo = {
  name: string
  type: string
  size: number
}

export type SharingFile = {
  file: File
  upload_id: string
}

const storageApiHelper = {
  // GET /api/v1/emails - List scheduled emails
  prepareUpload: async (fileInfos: FileInfo[]) => {
    const files = fileInfos.map((fileInfo) => {
      const { name, type, size } = fileInfo
      let content_type = type
      if (type == null || type.trim().length === 0) {
        if (name.toLowerCase().endsWith('iso') === true) {
          content_type = 'application/x-iso9660-image'
        }
      }
      return {
        filename: name,
        content_type,
        size: size,
      }
    })
    const res = await storageApiClient.post('/files/upload/prepare', { files })
    return res.data
  },

  upload: async (files: SharingFile[], onProgress, onBeforeSend) => {
    const formData = new FormData()
    const uploadIds = []
    files.forEach((file) => {
      formData.append('files', file.file)
      uploadIds.push(file.upload_id)
    })
    formData.append('upload_ids', JSON.stringify(uploadIds))
    const res = await storageApiClient.xhrPost('/files/upload', formData, onProgress, onBeforeSend)
    return res.data
  },

  cancelUpload: async (uploadId: string) => {
    const res = await storageApiClient.post(`/files/upload/cancel/${uploadId}`)
    return res.data
  },

  download: async (fileId: string) => {
    const res = await storageApiClient.get(`/files/download/${fileId}`)
    return res.data
  },

  getDownloadUrl: async (fileId: string) => {
    const url = `${conf.SERVER.storageApiURL}/files/download/${fileId}`
    return url
  },

  getInfo: async (fileId: string) => {
    const res = await storageApiClient.get(`/files/info/${fileId}`)
    return res.data
  },

  deleteFile: async (fileId: string) => {
    const res = await storageApiClient.delete(`/files/${fileId}`)
    return res.data
  },
}

export default storageApiHelper
